// constants
import { LOGIN_TYPE } from '@/constants/login';
export var EnvironmentEnum;
(function (EnvironmentEnum) {
    EnvironmentEnum[EnvironmentEnum["EPHEMERAL"] = 0] = "EPHEMERAL";
    EnvironmentEnum[EnvironmentEnum["PRODUCTION"] = 1] = "PRODUCTION";
    EnvironmentEnum[EnvironmentEnum["DEVELOPMENT"] = 2] = "DEVELOPMENT";
})(EnvironmentEnum || (EnvironmentEnum = {}));
export const getParamsFromEphemeralClient = () => {
    if (window.location.protocol === 'https:') {
        const [serviceWithEnv, location] = window.location.hostname.split('.');
        const env = serviceWithEnv.split('-').pop();
        const service = serviceWithEnv.split('-').slice(0, 4).join('-');
        return [service, env, location];
    }
    const [service, env, location] = window.location.hostname.split('.');
    return [service, env, location];
};
export const getEnvironmentViaHostname = () => {
    if (window.location.hostname === 'localhost') {
        return EnvironmentEnum.DEVELOPMENT;
    }
    else if (window.location.hostname.includes('im-ads-dashboard-client')) {
        return EnvironmentEnum.EPHEMERAL;
    }
    return EnvironmentEnum.PRODUCTION;
};
export const EnvConfigMap = {
    [EnvironmentEnum.DEVELOPMENT]: {
        get clientId() {
            return 'e3d63b8f-3ebe-4c0a-8e63-0136abf3c65e';
        },
        get partnerServiceBasePath() {
            return 'http://localhost:8080';
        },
        get clientBasePath() {
            return 'http://localhost:3000';
        },
        getOzoneHostName(loginType) {
            if (loginType === LOGIN_TYPE.INTERNAL)
                return 'https://ozone-idp-employees-http.nidashsf.in-west.swig.gy';
            return 'https://ozone-idp-brands-im-kba-http.nidashsf.in-west.swig.gy';
        },
    },
    [EnvironmentEnum.EPHEMERAL]: {
        get clientId() {
            return 'e3d63b8f-3ebe-4c0a-8e63-0136abf3c65e';
        },
        get partnerServiceBasePath() {
            const [_, env, location] = getParamsFromEphemeralClient();
            return `https://partner-service.${env}.${location}.swig.gy`;
        },
        get clientBasePath() {
            const [service, env, location] = getParamsFromEphemeralClient();
            return `https://${service}-${env}.${location}.swig.gy`;
        },
        getOzoneHostName(loginType) {
            const [_, env, location] = getParamsFromEphemeralClient();
            if (loginType === LOGIN_TYPE.INTERNAL)
                return `https://ozone-idp-employees-http-${env}.${location}.swig.gy`;
            return `https://ozone-idp-brands-im-kba-http-${env}.${location}.swig.gy`;
        },
    },
    [EnvironmentEnum.PRODUCTION]: {
        get clientId() {
            return 'f4e72b9a-5fde-4d1a-9e74-0237bcf4d67f';
        },
        get partnerServiceBasePath() {
            return 'https://partner-api.swiggy.com';
        },
        get clientBasePath() {
            return `https://${window.location.hostname}`;
        },
        getOzoneHostName(loginType) {
            if (loginType === LOGIN_TYPE.INTERNAL)
                return 'https://partner-api.swiggy.com';
            return 'https://ozone-idp-brands-im-kba.swiggy.com';
        },
    },
};
